import ReviewsFinalRatingStatus from '@/models/enums/ReviewsFinalRatingStatus'
import axios from 'axios'

const state = {
    finalRating: { value: null, status: ReviewsFinalRatingStatus.Increased },
}

const getters = {
    getFinalRating (state) {
      return state.finalRating
    },
}

const mutations = {
    setFinalRating (state, payload) {
      state.finalRating = payload
    },
}

const actions = {
    fetchFinalRating ({ rootGetters, commit }) {
        const url = rootGetters['api/fetchReviewsFinalRating']

        return axios
          .get(url, {
            params: {
              filialId: rootGetters['branches/getLocalStorageBranch'].id,
              date: rootGetters['orders/getSelectedDate'],
            },
          })
          .then(res => {
            commit('setFinalRating', res.data.data)
          })
          .catch(err => err)
      },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
